const enc = new TextEncoder();

export function stringNumBytes(str: string) {
  return enc.encode(str).length;
}
